// extracted by mini-css-extract-plugin
export default {"FullScreen":"B_C","inner":"B_E","appear":"B_F","swipe-position":"B_G","swipe-finger":"B_H"};